import Vue from 'vue'

Vue.filter('distance', (value) => {
  return ![null, undefined, NaN].includes(value) ? `${value} km` : 'N/A'
})
Vue.filter('distanceperh', (value) => {
  return value ? `${value} km/h` : 'N/A'
})

Vue.filter('money', (value) => {
  return '$ ' + Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(value)
})
